var map = {
	"./acid.png": 8757,
	"./aqua.png": 4786,
	"./autumn.png": 804,
	"./black.png": 1541,
	"./bumblebee.png": 7313,
	"./business.png": 7356,
	"./cmyk.png": 6658,
	"./coffee.png": 8478,
	"./corporate.png": 8205,
	"./cupcake.png": 6184,
	"./cyberpunk.png": 2275,
	"./dark.png": 738,
	"./dim.png": 4778,
	"./dracula.png": 8286,
	"./emerald.png": 2820,
	"./fantasy.png": 4490,
	"./forest.png": 3641,
	"./garden.png": 6993,
	"./halloween.png": 8841,
	"./lemonade.png": 4369,
	"./light.png": 9148,
	"./lofi.png": 6090,
	"./luxury.png": 2205,
	"./night.png": 386,
	"./nord.png": 3249,
	"./pastel.png": 9145,
	"./retro.png": 5932,
	"./sunset.png": 1776,
	"./synthwave.png": 7138,
	"./valentine.png": 3290,
	"./winter.png": 8609,
	"./wireframe.png": 3822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8737;